/**
 * MAGSDK basic implementation of downloads plugin.
 *
 * @author <bas.jsdev@gmail.com>
 */

'use strict';


var Emitter        = require('cjs-emitter'),
    gettextWrapper = require('mag-gettext'),
    plugin         = new Emitter(),
    downloads      = [],
    hash           = {},
    updateTime     = 2000,
    errors         = {
        wrongUrl:           {code: '-1', message: ''},
        wrongFileName:      {code: '-2', message: ''},
        fileAlreadyExist:   {code: '-3', message: ''},
        failedToCreateTask: {code: '-4', message: ''},
        wrongDownloadItem:  {code: '-5', message: ''},
        wrongPathToStorage: {code: '-6', message: ''}
    },
    timerId, gettext;


/**
 * Check for changes. If there are some emit corresponding events.
 */
function update () {
    var rawData, index, item, progress;

    try {
        rawData = JSON.parse(stbDownloadManager.GetQueueInfo());
    } catch ( error ) {
        rawData = [];
    }

    for ( index = 0; index < rawData.length; index++ ) {
        // correct state type
        rawData[index].state = Number(rawData[index].state);
        // if new item, trigger event
        if ( hash[rawData[index].id] ) {
            item = hash[rawData[index].id];
            // error task should have 0% progress
            if (
                rawData[index].state === plugin.states.PERMANENT_ERROR
                || rawData[index].state === plugin.states.TEMPORARY_ERROR
            ) {
                rawData[index].progressPct = 0;
            }
            progress = Math.ceil(rawData[index].progressPct);
            // check if progress changed (every running task)
            if ( rawData[index].state === plugin.states.RUNNING && progress !== item.data.progress ) {
                item.data.progress = progress;
                downloads[downloads.indexOf(item)].data.progress = progress;
                if ( plugin.events['progress'] ) {
                    plugin.emit('progress', {item: item, time: Date.now()});
                }
            }
            // check if state changed
            if ( rawData[index].state !== item.data.state ) {
                item.data.state = rawData[index].state;
                // fix progress bug (can stop at 99% because of long update time)
                if ( progress !== item.data.progress ) {
                    item.data.progress = progress;
                    downloads[downloads.indexOf(item)].data.progress = progress;
                }
                downloads[downloads.indexOf(item)].data.state = item.data.state;
                if ( plugin.events['state'] ) {
                    plugin.emit('state', {item: item, time: Date.now()});
                }
            }
        } else {
            item = new Emitter();
            item.data = {
                name:          rawData[index].filePath,
                id:            rawData[index].id,
                path:          rawData[index].mountPoint,
                priority:      rawData[index].prio,
                progress:      Math.ceil(rawData[index].progressPct >= 0 ? rawData[index].progressPct : 0),
                size:          rawData[index].sizeTotal,
                state:         rawData[index].state,
                url:           rawData[index].url,
                attempt:       rawData[index].attempt,
                priorityLevel: rawData[index].prioLevel,
                sizeDone:      rawData[index].sizeDone,
                tempFile:      rawData[index].tempFile,
                timeWasted:    rawData[index].timeWasted
            };
            // error task should have 0% progress
            if (
                item.data.state === plugin.states.PERMANENT_ERROR
                || item.data.state === plugin.states.TEMPORARY_ERROR
            ) {
                item.data.progress = 0;
            }

            item.pause = function () {
                stbDownloadManager.StopJob(this.data.id);
            };

            item.resume = function () {
                stbDownloadManager.StartJob(this.data.id);
            };

            hash[item.data.id] = item;
            downloads.push(item);
            if ( plugin.events['add'] ) {
                plugin.emit('add', {item: item, time: Date.now()});
            }
        }
    }
}


/**
 * Task possible states
 */
plugin.states = {
    STOPPED:         0,
    WAITING:         1,
    RUNNING:         2,
    FINISHED:        3,
    TEMPORARY_ERROR: 4,
    PERMANENT_ERROR: 5
};


plugin.add = function ( data, callback ) {
    if ( typeof callback !== 'function' ) {
        console.log('Wrong callback function.');

        return;
    }
    if ( !data.url ) {
        callback(errors.wrongUrl);

        return;
    }
    if ( !data.name ) {
        callback(errors.wrongFileName);

        return;
    }
    if ( gSTB.IsFileExist(data.name) ) {
        callback(errors.fileAlreadyExist);

        return;
    }
    if ( !stbDownloadManager.AddJob(data.url, data.name) ) {
        callback(errors.failedToCreateTask);

        return;
    }
    callback(null, true);
};


plugin.remove = function ( item, deleteFile, callback ) {
    if ( typeof callback !== 'function' ) {
        console.log('Wrong callback function.');

        return;
    }
    if ( !item || !(item instanceof Emitter) ) {
        callback(errors.wrongDownloadItem);

        return;
    }
    stbDownloadManager.DeleteJob(item.data.id, !!deleteFile);
    delete hash[item.data.id];
    downloads.splice(downloads.indexOf(item), 1);

    callback(null, true);

    if ( plugin.events['remove'] ) {
        plugin.emit('remove', {item: item, time: Date.now()});
    }
};


plugin.restore = function ( path, callback ) {
    if ( typeof callback !== 'function' ) {
        console.log('Wrong callback function.');

        return;
    }
    if ( !path ) {
        callback(errors.wrongPathToStorage);

        return;
    }
    stbDownloadManager.RestoreJobs(path);

    callback(null, true);

    if ( plugin.events['restore'] ) {
        plugin.emit('restore', {time: Date.now()});
    }
};


// Storage was removed so find and delete tasks connected to this storage.
plugin.validate = function () {
    var trashStorages = [],
        realStorages  = [],
        trashTasks    = [],
        storages, index, path;

    //console.log(stbDownloadManager.GetQueueInfo());
    try {
        storages = JSON.parse(gSTB.GetStorageInfo('{}'));
        storages = storages.result;
    } catch ( error ) {
        console.log(error);
        storages = [];
    }

    for ( index = 0; index < storages.length; index++ ) {
        realStorages.push(storages[index].mountPath);
    }
    for ( index = 0; index < downloads.length; index++ ) {
        path = downloads[index].data.path;
        if ( realStorages.indexOf(path) === -1 ) {
            trashTasks.push(downloads[index]);
        }
        if ( realStorages.indexOf(path) === -1 && trashStorages.indexOf(path) === -1 ) {
            trashStorages.push(path);
        }
    }
    // clean up all bad tasks
    trashTasks.forEach(function ( item ) {
        //console.log('delete id: ' + item.data.id);
        if ( plugin.events['remove'] ) {
            plugin.emit('remove', {item: item, time: Date.now()});
        }
        delete hash[item.data.id];
        downloads.splice(downloads.indexOf(item), 1);
    });
    // clean up all bad storages and trash tasks
    trashStorages.forEach(function ( pathToCatalog ) {
        stbDownloadManager.InvalidateCatalog(pathToCatalog);
    });
};


Object.defineProperties(plugin, {
    list: {
        get: function () {
            return downloads;
        }
    },
    updateInterval: {
        get: function () {
            return updateTime;
        },
        set: function ( newTime ) {
            updateTime = newTime;
            clearInterval(timerId);
            timerId = setInterval(update, updateTime);
        }
    }
});


plugin.reset = function () {
    downloads = [];
    hash = {};
};


// first launch
update();
// check info and trigger events if something happened
timerId = setInterval(update, updateTime);


module.exports = {
    onInit: function ( config, callback ) {
        gettextWrapper.load({
            name: window.core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;

            errors.wrongUrl.message           = gettext('Wrong url.');
            errors.wrongFileName.message      = gettext('Wrong fileName.');
            errors.fileAlreadyExist.message   = gettext('File already exist.');
            errors.failedToCreateTask.message = gettext('Failed to create download.');
            errors.wrongDownloadItem.message  = gettext('Wrong download item.');
            errors.wrongPathToStorage.message = gettext('Wrong path to storage.');

            callback();
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, plugin);
    }
};
